<template>
  <div class="w-full h-500 relative">
    <div class="w-full absolute">
      <div class="h-500 absolute bg-gradient-to-tr from-black-50 to-transparent z-10 w-full">

      </div>
      <video id="background-video" class="background-video" autoplay loop muted>
        <source src="../assets/nexee-vid.mp4" type="video/mp4">
      </video>
    </div>
    <div class="z-20 absolute pt-14 lg:pt-20 top-28 left-4 lg:left-24">
      <h1 class="font-benzin text-white text-4xl uppercase tracking-wide font-normal">About us</h1>
      <p class="font-poppins text-white text-xl max-w-md">Powering smarter, faster, better-connected communities and helping people thrive.</p>
    </div>
  </div>

  <div class="bg-white py-12 lg:py-20 px-4 lg:px-24 bg-orange-corner">
    <div>
      <div class="text-left col-start-1 flex flex-col mb-28 lg:mb-0 pb-40 lg:pb-0">
          <p class="font-benzin text-black text-3xl tracking-normal font-normal py-0 my-0 uppercase">We are <span class="text-brand-primary">Digital enablers</span></p>
          <p class="text-md lg:text-lg text-black font-poppins tracking-normal pt-6 py-0 my-0 max-w-lg">Nexee delivers fibre broadband services for new and existing developments around Australia. In today’s digital-first world, Smart Living is more than technology; it’s about empowering people and communities to thrive and enhance life through seamless connectivity.</p>
          <div class="px-0 lg:px-6 py-8 lg:py-12">
            <p class="font-poppins text-black text-xl lg:text-3xl tracking-wide font-bold py-0 pb-6 my-0">Smart Living <span class="text-brand-primary">starts here.</span></p>
            <p class="text-md lg:text-lg text-black font-poppins tracking-normal pt-2 py-0 my-0 max-w-lg font-normal pb-4 lg:pb-8">Where houses become smart homes, developments transform into vibrant communities, and ambitions turn into realities. Nexee is the foundation for a better connected life.</p>
            <p class="font-poppins text-black text-xl lg:text-3xl tracking-wide font-bold py-0 my-0 pb-6">Smart Living <span class="text-brand-primary">happens now.</span></p>
            <p class="text-md lg:text-lg text-black font-poppins tracking-normal pt-2 py-0 my-0 max-w-lg font-normal pb-4 lg:pb-8">A fast-moving world demands immediate, responsive solutions. From powering work and entertainment to enabling smart devices, we deliver speed and reliability for today’s needs.</p>
            <p class="font-poppins text-black text-xl lg:text-3xl tracking-wide font-bold py-0 my-0 pb-6">Smart Living <span class="text-brand-primary">is always on.</span></p>
            <p class="text-md lg:text-lg text-black font-poppins tracking-normal pt-2 py-0 my-0 max-w-lg font-normal pb-4 lg:pb-8">It’s uninterrupted connectivity that works as hard as you do. With tailored, direct-to-you fibre, advanced technologies, and local expertise, we make Smart Living a reality and improve wellbeing.</p>
          </div>
          <p class="font-benzin text-brand-primary text-3xl lg:text-5xl tracking-wide font-normal py-0 my-0 uppercase">HERE. NOW. <span class="text-black font-benzin-black">ON.</span></p>
          <p class="text-lg text-black font-poppins tracking-normal pt-2 lg:pt-6 py-0 my-0 max-w-lg">Always here. Always ready. Always connected.</p>

        </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import HeroText from '../components/content/HeroText.vue';
import Text from '../components/content/Text.vue';
import Container from '../components/content/Container.vue';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const legalDocuments = brandService.getLegalDocuments();
</script>
<style scoped>
/* video background */
.background-video {
  height: 750px;
  overflow: hidden;
  width: 100vw;
  object-fit: cover;
  position: relative;
  left: 0;
  right: 0;
  top: 90px;
  bottom: 0;
  z-index: 1;
}

.h-500 {
  height: 600px;
  overflow: hidden;
}

.from-black-50 {
  --tw-gradient-from: #00000092 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.bg-orange-corner {
  background-repeat: no-repeat;
  background-color: transparent;
  background-image: url("https://uniti-bpo-website-assets.assets.unitiinternet.com/NEX/aboutus-bg.png");
  background-position: right center;
  background-size: contain;
  height: 100%;
}

@media only screen and (max-width: 768px) {
  .bg-orange-corner {
    background-repeat: no-repeat;
    background-color: transparent;
    background-image: url("https://uniti-bpo-website-assets.assets.unitiinternet.com/NEX/aboutus-bg-mobile.png");
    background-position: bottom center;
    background-size: contain;
    height: 100%;
  }
}
</style>
